/* RESPONSIBLE TEAM: team-automation-foundations */
import FinAiAgentCustomAnswersAnswerRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/custom-answers/answer';

export default class ResolutionBotAnswersAnswerRoute extends FinAiAgentCustomAnswersAnswerRoute {
  analytics = {
    section: 'resolution-bot',
    place: 'answer',
  };

  controllerName = 'apps.app.automation.fin-ai-agent.custom-answers.answer';
  templateName = 'apps.app.automation.fin-ai-agent.custom-answers.answer';
}
